import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Text,
} from "@chakra-ui/react"
import type { FC } from "react"

import CardContainer from "common/components/CardContainer"
import Link from "common/components/Link"
import MarkdownViewer from "common/components/MarkdownViewer"
import { ROUTES } from "common/constants/routes"
import { getOrganizationFAQs } from "whitelabel/constants/faqs"
import { useIsWhiteLabel } from "whitelabel/hooks/useIsWhiteLabel"
import { getWhiteLabelRoute } from "whitelabel/utils/breadcrumb"
import type { Organization } from "query/graphql"

type Props = {
  title: string
  displayViewAll?: boolean
  organization: Organization
}
const FaqsList: FC<Props> = ({
  organization,
  title,
  displayViewAll = false,
}) => {
  const isWhitelabel = useIsWhiteLabel()
  const faqs = getOrganizationFAQs(organization.id)

  if (!faqs?.length) return null

  return (
    <CardContainer
      isFullHeightView
      isTableView
      title={title}
      topRight={
        displayViewAll ? (
          <Box textAlign="right" width="100%">
            <Link
              color="gray.500"
              href={
                isWhitelabel
                  ? getWhiteLabelRoute(ROUTES.governance.faq(organization.slug))
                  : ROUTES.governance.faq(organization.slug)
              }
            >
              View all
            </Link>
          </Box>
        ) : null
      }
    >
      <Accordion allowToggle>
        {faqs.map((faq, idx) => (
          <AccordionItem
            key={`faq_${faq.title}`}
            borderTop={idx === 0 ? "none" : "auto"}
          >
            <AccordionButton justifyContent="space-between" px={6} py={4}>
              <Text fontSize="sm">{faq.title}</Text>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel px={6}>
              <Text fontSize="sm">
                <MarkdownViewer content={faq.content} />
              </Text>
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </CardContainer>
  )
}

export default FaqsList
